<!--~
~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
~ to an End-User License Agreement included in a separate file named EULA.txt
~ that is distributed with this file.
-->
<button mat-button fxShow fxHide.lt-md
  [matMenuTriggerFor]='userMenu'
  matTooltip='View user options'>
  <span>{{ username$ | async }}</span>
  <mat-icon svgIcon='person'></mat-icon>
</button>
<button mat-icon-button fxHide fxShow.lt-md
  [matMenuTriggerFor]='userMenu'
  matTooltip='View user options'>
  <mat-icon svgIcon='person'></mat-icon>
</button>
<mat-menu #userMenu='matMenu'>
  @if (!((activeMethod$ | async) === 'oidc' || (isDefaultUser$ | async))) {
    <div mat-menu-item (click)='showResetForm()'>
      <mat-icon svgIcon='change-password'></mat-icon>
      <span>Update Password</span></div>
    }
    <dash-gis-logout [inMenu]='true' [showIcon]='true'></dash-gis-logout>
  </mat-menu>
